import { RenderElementProps } from 'slate-react';

import { FontSizeModeEnum } from '../types';

export enum FontSizeElementVariants {
  H1 = 'heading-one',
  H2 = 'heading-two',
  PARAGRAPH_BULLET = 'paragraph-bullet',
  PARAGRAPH = 'paragraph',
}

export interface FontSizeSwitcherElementProps extends RenderElementProps {
  /**
   * Additional class name to provide on the root element.
   */
  className?: string;
  fontSizeMode?: FontSizeModeEnum;
  isHideParagraphIndex?: boolean;
}
